import * as React from 'react';
import {connect} from 'react-redux';

import type {User} from 'nutshell-core/users/users-types';

import {fetchSchemaAction} from '../forms/forms-actions';
import {PageWrapper} from '../layout/page-wrapper';

import {EmailMarketingRoutes, getEmailMarketingSidebar, getPageContainerHeader} from './routes';
import {EmailMarketingRedirectRoutes} from './routes/email-marketing-redirect-routes';

export const DEFAULT_EMAIL_MARKETING_REDIRECT_PATH = '/marketing/dashboard';

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        fetchFormSchema() {
            dispatch(fetchSchemaAction());
        },
    };
}

type OwnProps = {
    user: User | null | undefined;
};

type DispatchProps = {
    fetchFormSchema: () => void;
};

type Props = OwnProps & DispatchProps;

export function EmailMarketingRootComponent(props: Props) {
    React.useEffect(() => {
        props.fetchFormSchema();
    });

    if (!props.user) {
        return null;
    }

    const hasFullAccessToCampaigns = props.user.permissions.canAccessFullCampaigns;

    return (
        <PageWrapper
            header={getPageContainerHeader(window.location.pathname)}
            sidebar={getEmailMarketingSidebar(window.location.pathname, props.user)}
        >
            <EmailMarketingRoutes hasFullAccessToCampaigns={hasFullAccessToCampaigns} />
            <EmailMarketingRedirectRoutes />
        </PageWrapper>
    );
}

// @ts-expect-error
const connector = connect<Props, OwnProps, DispatchProps, _, _, _>(null, mapDispatchToProps);
export const EmailMarketingRoot = connector(EmailMarketingRootComponent);
